import { forwardRef, memo, useMemo } from 'react';
import { BzTab } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { updateDefaultManageColumnName, updateStrViewType } from '../../redux/actions/watchlist';
import { handleModal } from '../../redux/actions/modals';
import { DEFAULT_MANAGE_COLUMN_PROFILE_NAME, GRID_VIEW, MANAGE_COLUMNS_VIEW_TYPES, POSITION_TYPES } from '../../utils/global_variables';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { bIsProd } from '../../utils/global_functions';


const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));
const HoldingsPositionsTabs = ({ arrHoldingssNetPostion, activeTabs, arrKababDropdown, setIsSuppressMenu, setActiveTabs, kababDropdownoptionsOnClickHandler, ...props }) => {
    const dispatch = useDispatch();
    /*Mahesh S  : 01-06-2023 : BT-107422 -  Breeze- Positions Overview - Start*/
    const { todaysPostions, overAllPositions } = useSelector(state => state.netPosition);
    const todaysCount = useMemo(() => todaysPostions?.length, [todaysPostions]);
    const overAllCount = useMemo(() => overAllPositions?.length, [overAllPositions]);
    /*Mahesh S  : 01-06-2023 : BT-107422 -  Breeze- Positions Overview - End*/


    const isOrderReportShow = useMemo(() => {
        if (activeTabs === POSITION_TYPES.OVERALL) {
            if (overAllPositions?.length) {
                return true
            } else { return false }
        } else if (activeTabs === POSITION_TYPES.TODAYS) {
            if (todaysPostions?.length) {
                return true
            } else { return false }
        } else { }
    }, [activeTabs, overAllPositions, todaysPostions,])

    const futureKebabDropdownoptionsOnClickHandler = (value) => {
        if (value === "0") {
            dispatch(updateDefaultManageColumnName(DEFAULT_MANAGE_COLUMN_PROFILE_NAME.NETPOSITION));
            dispatch(updateStrViewType(MANAGE_COLUMNS_VIEW_TYPES?.NET_POSITION_VIEW_TYPE));
            dispatch(handleModal([{ "WATCHLIST_MANAGE_COLUMNS_MODAL": true }]));
        } else {
            dispatch(handleModal([{ "POSITION_REPORT": true }]));
        }
    }
    const arrOrdersKebabOtions = useMemo(() => [
        { id: '0', value: '0', content: GRID_VIEW.MANAGE_COLUMNS_VIEW },
        { id: '1', value: '1', content: 'Position Report' },
    ], [activeTabs])



    return (
        <div>
            {
                arrHoldingssNetPostion.map((each) => (
                    <BzTab className='OrderTab' tabKey={`tab${each.tab_key}`} key={each.id} isActive={activeTabs === each.tab_key} onClick={() => setActiveTabs(each.tab_key)}>
                        <div className='d-flex align-items-center gap-2'>
                            <div className={`navtitle ${activeTabs === each.tab_key ? 'color-active-text' : ''} me-1 mt-1`}>{each.name}({each.name === 'Today\'s' ? todaysCount : each.name === 'Overall' ? overAllCount : ''})</div>
                            {activeTabs === each.tab_key ?
                                <>
                                    {/*Code is been commented as of now will be implemented in next phase by Sumit & Ashwini */}
                                    {/* <div className='clear-background me-2'>
                                        <TabsMenus arrKababDropdown={arrKababDropdown} kababDropdownoptionsOnClickHandler={kababDropdownoptionsOnClickHandler}>
                                        </TabsMenus>
                                    </div> */}
                                    {/*Code is been commented as of now will be implemented in next phase by Sumit & Ashwini */}
                                </>
                                : null}
                            <Dropdown className='dropdown-kebab'>
                                <Dropdown.Toggle as={CustomDropdownToggle} className='p-0 m-0'>
                                    <div className={`icon-14 icon-kebab d-flex flex-shrink-0 mt-1 ${activeTabs === each.tab_key ? 'icon-light' : 'icon-dark'}`}></div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {
                                        arrOrdersKebabOtions?.map((eachOption) => (
                                            <Dropdown.Item disabled={!isOrderReportShow} key={eachOption.id} value={eachOption.value} onClick={(e) => futureKebabDropdownoptionsOnClickHandler(eachOption.value)}>
                                                <Container fluid className='p-0'>
                                                    <Row className='g-0' >
                                                        <Col md={12} className='d-flex justify-content-between align-self-center'>
                                                            <div className='text-nowrap text-truncate'>{eachOption.content}</div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Dropdown.Item>
                                        ))
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </BzTab>
                ))
            }

        </div >
    );

};

export default memo(HoldingsPositionsTabs);